<template>
  <div v-if="visible" class="violation-modal" @click.self="close">
    <div class="violation-dialog">
      <header class="violation-dialog__head">
        <div class="violation-dialog__title-wrap">
          <span class="violation-dialog__accent"></span>
          <span class="violation-dialog__title">违规记录</span>
          <span class="violation-dialog__product">{{ productTitle }}</span>
        </div>
        <button class="violation-dialog__close" type="button" aria-label="关闭" @click="close">×</button>
      </header>

      <div v-loading="loading" class="violation-dialog__content">
        <div v-if="error && !loading" class="violation-dialog__state">
          <p>违规记录加载失败</p>
          <el-button size="small" type="primary" @click="load">重试</el-button>
        </div>
        <el-empty v-else-if="!loading && !records.length" description="暂无违规记录" :image-size="80" />
        <div v-else class="violation-dialog__table-wrap">
          <el-table :data="records" size="small" stripe height="100%">
<!--            <el-table-column prop="violation_id" label="违规编号" min-width="150" show-overflow-tooltip />-->
            <el-table-column prop="violation_title" label="违规标题" min-width="200" show-overflow-tooltip />
            <el-table-column prop="violation_type" label="违规类型" min-width="140" show-overflow-tooltip />
<!--            <el-table-column prop="violation_product" label="违规商品ID" min-width="150" show-overflow-tooltip />-->
            <el-table-column label="违规时间" min-width="160">
              <template slot-scope="scope">{{ formatViolationTime(scope.row.violation_time) }}</template>
            </el-table-column>
            <el-table-column prop="status" label="处理状态" min-width="110" />
          </el-table>
        </div>
      </div>

      <footer class="violation-dialog__foot">
        <el-pagination
          v-if="!error && total > 0"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          layout="total, prev, pager, next"
          @current-change="changePage"
        />
        <el-button size="small" @click="close">关闭</el-button>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ViolationDialog',
  props: {
    visible: { type: Boolean, default: false },
    product: { type: Object, default: null }
  },
  data() {
    return {
      loading: false,
      error: false,
      records: [],
      page: 1,
      pageSize: 10,
      total: 0,
      requestSequence: 0
    }
  },
  computed: {
    productTitle() {
      const product = this.product || {}
      return `${product.title || '-'}（来源ID：${product.source_product_id || '-'}）`
    }
  },
  watch: {
    visible(value) {
      if (value) {
        this.page = 1
        this.load()
      } else {
        this.requestSequence += 1
        this.loading = false
      }
    },
    'product.id'(id, oldId) {
      if (this.visible && id !== oldId) {
        this.page = 1
        this.load()
      }
    }
  },
  beforeDestroy() {
    this.requestSequence += 1
  },
  methods: {
    ...mapActions({ getViolations: 'ucenter/getCloudProductViolations' }),
    load() {
      const id = this.product && this.product.id
      const sequence = ++this.requestSequence
      this.loading = true
      this.error = false
      this.records = []
      this.total = 0
      if (!id) {
        this.fail(sequence)
        return
      }
      this.getViolations({
        id,
        data: { page: this.page, page_size: this.pageSize },
        success: (res) => {
          if (!this.isCurrentRequest(sequence, id)) return
          this.loading = false
          if (!res || (res.code !== 200 && res.code !== 0) || !res.data || !Array.isArray(res.data.list)) {
            this.fail(sequence)
            return
          }
          this.records = res.data.list
          this.total = Number(res.data.total) || 0
          this.page = Number(res.data.page) || this.page
          this.pageSize = Number(res.data.page_size) || this.pageSize
        },
        error: () => this.fail(sequence)
      })
    },
    isCurrentRequest(sequence, id) {
      return sequence === this.requestSequence && this.visible && this.product && this.product.id === id
    },
    fail(sequence) {
      if (sequence !== this.requestSequence) return
      this.loading = false
      this.error = true
      this.records = []
    },
    changePage(page) {
      if (page === this.page) return
      this.page = page
      this.load()
    },
    formatViolationTime(timestamp) {
      if (timestamp === null || timestamp === undefined || timestamp === '') return '--'
      const value = Number(timestamp)
      if (!Number.isFinite(value) || value <= 0) return '--'
      const date = new Date(value * 1000)
      if (Number.isNaN(date.getTime())) return '--'
      const pad = number => String(number).padStart(2, '0')
      return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
    },
    close() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped>
.violation-modal {
  position: fixed;
  inset: 0;
  z-index: 901;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, .45);
}
.violation-dialog {
  display: flex;
  flex-direction: column;
  width: 1080px;
  max-width: 100%;
  max-height: 78vh;
  min-height: 360px;
  overflow: hidden;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 56px rgba(0, 0, 0, .22);
}
.violation-dialog__head,
.violation-dialog__foot {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 12px 18px;
}
.violation-dialog__head {
  border-bottom: 1px solid #e0e0ec;
  background: #f5f0e8;
}
.violation-dialog__title-wrap {
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 9px;
}
.violation-dialog__accent {
  width: 4px;
  height: 18px;
  flex: 0 0 4px;
  border-radius: 2px;
  background: #c8443c;
}
.violation-dialog__title {
  color: #1a1a2e;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}
.violation-dialog__product {
  overflow: hidden;
  color: #777;
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.violation-dialog__close {
  border: 0;
  background: transparent;
  color: #999;
  font-size: 22px;
  line-height: 1;
  cursor: pointer;
}
.violation-dialog__content {
  flex: 1;
  min-height: 0;
  padding: 14px 18px;
  overflow: hidden;
  background: #fafafa;
}
.violation-dialog__table-wrap {
  height: 100%;
  min-height: 220px;
}
.violation-dialog__state {
  padding: 50px 0;
  color: #909399;
  text-align: center;
}
.violation-dialog__foot {
  justify-content: flex-end;
  gap: 16px;
  border-top: 1px solid #e0e0ec;
  background: #fff;
}
@media (max-width: 640px) {
  .violation-modal { padding: 10px; }
  .violation-dialog { min-height: 300px; }
  .violation-dialog__head,
  .violation-dialog__foot { padding: 10px; }
  .violation-dialog__content { padding: 10px; }
  .violation-dialog__foot { align-items: flex-end; }
}
</style>
